import axios from 'axios';

export const netlifyHook = () => axios({
	method: 'post',
	url:'https://api.netlify.com/build_hooks/62ddab4fa363652100531540'
});

export default netlifyHook;